
export const lorawanthreadtext = {
    id: "Id",
    servertype: "Type de serveur",
    group: "Entité",
    frequency: "Fréquence d'exécution",
    lastrun: "Date de dernière exécution",
    lastlog: "Derniers retours",
    edition: "Modification du thread",
    del: "Supprimer le thread",
    delconfirm: "Etes vous sur de vouloir supprimer le thread?",
    delok: "Thread supprimé",
    nothread: "Aucun thread",
}
